import React from 'react';
import {useTranslation} from "react-i18next";
import {Text} from "../../../index";

const AiAgentsForWork = () => {
    const {t} = useTranslation();

    return (
        <div className="meeting-step">
            <Text size="f16" font="book" color="black">{t('ai_agents_for_work_title')}</Text>
            <div style={{margin: '20px 0'}}/>
            <Text size="f16" font="book" color="#9898A6">{t('ai_agents_for_work_footer')}</Text>
        </div>
    );
};

export default AiAgentsForWork;